import { memo } from 'react';
import { EditableCell } from './EditableCell';
import { formatDecimal } from '@/utils/formatNumber';
import type { Project } from '@/api/client';

interface SizeCellProps {
  project: Project;
}

export const SizeCell = memo(function SizeCell({ project }: SizeCellProps) {
  const value = project.size;

  const display = value != null ? (
    <div className="projects-table__base-cell">
      <strong>{formatDecimal(value)}</strong>
    </div>
  ) : null;

  return (
    <EditableCell project={project} fieldKey="size">
      {display ?? <span className="projects-table__empty-value">N/A</span>}
    </EditableCell>
  );
});
